/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getScreenRight } from "utils/generic";
import { blank } from "utils/generic";
import { useDispatch } from "react-redux";
import { getStandardFeatureById } from "utils/superAdminApi";
import { validateField } from "utils/generic";
import { updateStandardFeatureData } from "utils/superAdminApi";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";


const errMsg = {
  color: `red`,
  fontSize: `11px`,
};


let routePath = "/standardFeatures";


function EditStandardPlanFeature() {

  const { id } = useParams();
  const [disableColor, setDisableColor] = useState(false);
  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [screenName, setScreenName] = useState("Add Standard Feature");
  const [featureNameErr, setFeatureNameErr] = useState(false);
  const [featureSequenceErr, setFeatureSequenceErr] = useState(false);


  const [values, setValues] = React.useState({
    featureType: "Count Based",
    featureName: "",
    featureSequence: "",
    featureStatus: "Active",
  });



  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  useEffect(() => {
    setScreenName("Edit Standard Feature");
    (async () => {
      getRight()
      if (id !== undefined) {
        values._id = id
        getStandardFeatureById(values, (data) => {
          setValues(data.Result_Output);
        }, dispatch)
      }
    }
    )();
  }, [dispatch])

  async function getRight() {
    let right = await getScreenRight("Standard Plan Features")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)

  }

  const clearErrorStates = () => {
    setFeatureNameErr(false);
    setFeatureSequenceErr(false);
  };

  const addStandardFeature = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.featureName, setFeatureNameErr) || mandateFlag;
    mandateFlag = validateField(values.featureSequence, setFeatureSequenceErr) || mandateFlag;

    if (mandateFlag) {
      return;
    }

    updateStandardFeatureData(values, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const handleKeyDown = (e) => {
    const inputElement = document.querySelector('.GoogleInput');
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };




  return (
    <DashboardLayout>
      <DashboardNavbar screenName=' Edit Standard Plan Feature' />

      <MDBox mt={6} mb={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} spacing={6}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <MDBox pt={1.6} mb={-1.5} px={2}>
                <Grid container columnSpacing={5}>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="Feature Name"
                          variant="outlined"
                          fullWidth
                          value={values.featureName}
                          onChange={handleChange("featureName")}
                          disabled
                        />
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox mb={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Feature Type</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          // style={{ minHeight: "3em" }}
                          style={{ minHeight: "44.13px" }}
                          label="Feature Type"
                          value={values.featureType}
                          onChange={handleChange("featureType")}
                          disabled
                        >
                          <MenuItem value="Count Based">Count Based</MenuItem>
                          <MenuItem value="Selection Based - Yes/No">
                            Selection Based - Yes/No
                          </MenuItem>
                          <MenuItem value="Range Based">Range Based</MenuItem>
                        </Select>
                      </FormControl>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="Feature Sequence"
                          variant="outlined"
                          fullWidth
                          value={values.featureSequence}
                          inputProps={{
                            pattern: '^[0-9]+$',
                            maxLength: 3,
                        }}
                          onChange={handleChange("featureSequence")}
                        />
                          {featureSequenceErr ? <p style={errMsg}>Feature Sequence can't be blank</p> : ""}
                      </MDBox>
                    
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Feature Status</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        name="userType"
                        id="demo-simple-select"
                        // style={{ minHeight: "3em" }}
                        style={{ minHeight: "44.13px" }}
                        label="Feature Status"
                        value={values.featureStatus}
                        onChange={handleChange("featureStatus")}
                      >
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>

          </Grid>
        </Grid>
        {/* <Grid
          container
          mt={2}
          // columnSpacing={4}
          columnSpacing={{ xs: 2, md: 4, lg: 5}}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} lg={1.8}>
            <Link to={"/standardFeatures"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ width: "165px", height: "40px" }}
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4}  lg={1.8}>
            <MDButton
              onClick={disableColor ? blank : addStandardFeature}
              rel="noreferrer"
              variant="gradient"
              className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"}
              fullWidth
              style={{ width: "165px", height: "40px" }}
            >
              Update
            </MDButton>
          </Grid>

        </Grid> */}

<Grid
          container
          mt={2}
          columnSpacing={{ xs: 2, md: 4, lg: 4 }}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4}  lg={1.67}>
            <Link to={"/standardFeatures"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ width: "165px", height: "40px" }}
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} lg={1.67}>
            <MDButton
              onClick={disableColor ? blank : addStandardFeature}
              rel="noreferrer"
              variant="gradient"
              className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"}
              fullWidth
              style={{ width: "165px", height: "40px" }}
            >
              Update
            </MDButton>
          </Grid>

        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default EditStandardPlanFeature;
